import React from 'react'
import { Helmet } from 'react-helmet'
import { Waypoint } from 'react-waypoint'
import { Row, Col } from 'antd'
import { compose } from 'redux'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { FadeInTop, Banner, AspectRatioImage } from '@client/components/index'
import { AppContainer } from '@client/containers/index'
import styles from './AboutUs.styl'

import bannerImage from './images/about-team-banner.jpg'
import memberImage1 from './images/about-member1.jpg'
import memberImage2 from './images/about-member2.jpg'
import memberImage3 from './images/about-member3.jpg'
import memberImage4 from './images/about-member4.jpg'
import memberImage5 from './images/about-member5.jpg'
import memberImage6 from './images/about-member6.jpg'

const duration = 500
const memberList = [
  {
    name: '張希慈',
    cover: memberImage1,
    title: '執行長',
    description: '擅長青年活動引導、企劃、品牌經營',
    delay: 200,
  },
  {
    name: '楊御廷',
    cover: memberImage2,
    title: '授權管理總監',
    description: '擅長國際事務、策略規劃',
    delay: 400,
  },
  {
    name: '陳思伶',
    cover: memberImage3,
    title: '授權管理副總監',
    description: '擅長教育團隊經營、行政業務',
    delay: 600,
  },
  {
    name: '林浩崴',
    cover: memberImage4,
    title: '財務資訊總監',
    description: '擅長後勤行政支援、學生社群經營',
    delay: 800,
  },
  {
    name: '吳依庭',
    cover: memberImage5,
    title: '實習生',
    description: '負責流浪挑戰賽授權',
    delay: 1000,
  },
  {
    name: '蘇庭妤',
    cover: memberImage6,
    title: '實習生',
    description: '負責國際年會規劃、品牌行銷',
    delay: 1200,
  },
]

class AboutUs extends React.Component {
  state = {
    showMember: false,
    showArticle: false,
  }

  static propTypes = {
    t: PropTypes.func.isRequired,
  }

  render() {
    const { t } = this.props
    return (
      <AppContainer style={{ paddingTop: 0 }}>
        <Helmet>
          <title>{t('關於我們')}</title>
        </Helmet>
        {/* banner */}
        <Banner backgroundImage={bannerImage} />

        <Waypoint
          bottomOffset="50px"
          onEnter={() => {
            this.setState({ showArticle: true })
          }}
        />

        <section
          className={styles.section}
          style={{ display: this.state.showArticle ? 'block' : 'none' }}
        >
          <FadeInTop show={this.state.showArticle} duration={duration} delay={0}>
            <Row type="flex" justify="center">
              <Col>
                <h1 className={styles.title}>{t('關於城市浪人')}</h1>
              </Col>
            </Row>
          </FadeInTop>
          <Row type="flex" justify="center">
            <Col xs={18} sm={14}>
              <FadeInTop show={this.state.showArticle} duration={duration} delay={1000}>
                <article className={styles.article}>
                  <p>
                    {t(
                      '如果有更多年輕人願意一起來思索改進社會的方法並嘗試改變，而他們也能在其中找到自己的使命與價值，是不是能讓這些即將步入社會的青年更有自信、更堅韌地面對世界的變遷，也讓我們邁向更具同理心更適性發展的公民社會。',
                    )}
                  </p>
                  <p>
                    {t(
                      '在這樣的想法之下，一群大學生在2013年發想出創新的體驗教育模式－流浪挑戰賽，並在2015年正式註冊成為帶領年輕人探索自我與使命的「社團法人國際城市浪人育成協會」。流浪挑戰賽透過遊戲式引導與獨家的任務設計，帶領青年跨出舒適圈去探索自身的熱誠、接觸多元的族群與議題，讓他們開始試著用自己的力量為社會創造正面能量，在意識到自己有能力影響他人與社會後，從中找到自己的價值與使命，繼而在實現理想過程中為社會帶來正向的改變。',
                    )}
                  </p>
                  <p>
                    {t(
                      '我們希望透過創新的教育服務，提升16-26歲的青年對自我的瞭解和對社會的參與度，並在接觸不同背景文化的族群後，培養出同理心、尊重感謝的心、人際力、實踐力等世界公民素養。我們相信：改變世界，不是一個人做了很多很多，而是很多人都做了一點點。',
                    )}
                  </p>
                </article>
              </FadeInTop>
            </Col>
          </Row>
        </section>
        <Waypoint
          bottomOffset="50px"
          onEnter={() => {
            this.setState({ showMember: true })
          }}
        />
        <section
          className={styles.section}
          style={{ display: this.state.showMember ? 'block' : 'none' }}
        >
          {/* title */}
          <FadeInTop show={this.state.showMember} duration={duration} delay={0}>
            <Row type="flex" justify="center">
              <Col>
                <h1 className={styles.title}>{t('團隊介紹')}</h1>
              </Col>
            </Row>
          </FadeInTop>
          {/* members */}
          <Row type="flex" justify="center">
            {memberList.map((member) => (
              <Col key={member.name} xs={16} md={8}>
                <FadeInTop
                  className={styles.member}
                  show={this.state.showMember}
                  duration={duration}
                  delay={member.delay}
                >
                  <AspectRatioImage className={styles.cover} src={member.cover} ratio={3 / 4} />
                  <h4 className={styles.name}>{t(member.name)}</h4>
                  <div className={styles.title}>{t(member.title)}</div>
                  <div className={styles.description}>{t(member.description)}</div>
                </FadeInTop>
              </Col>
            ))}
          </Row>
        </section>
      </AppContainer>
    )
  }
}

export default compose(withTranslation())(AboutUs)
